import { Box, Stack, SxProps, Typography } from '@mui/material';
import Picture from './Picture';

interface Props {
  sdgCount?: number;
  sx?: SxProps;
}

const SdgCountTile: React.FC<Props> = ({ sdgCount, sx }) => {
  return (
    <Box sx={{ color: '#0076FF', ...sx }}>
      <Stack direction={'row'} spacing={1} alignItems={'baseline'}>
        <Picture
          srcSet='https://res.cloudinary.com/carbonclick/image/upload/v1696936641/sdg_icon_cxxtly.svg'
          alt='goals icon'
          sx={{ '& img': { width: 'auto', height: 30 } }}
        />

        <Typography variant='ticker2'>{sdgCount}</Typography>
      </Stack>
      <Typography variant='ticker1Label'>Goals addressed</Typography>
    </Box>
  );
};

export default SdgCountTile;
